import { useState } from 'react';
import { Button, styled } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { LIMIT_PAGE } from '../../utils/transformMeetingObjectives';


const ContentWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 6px;
  margin: 12px 15px 0px 0px;
  height: 28px;
  overflow: hidden;
`;

const StyledSpan = styled('span')`
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.46px;
  text-transform: capitalize;
`;

const StyledButton = styled(Button)`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: rgba(10, 21, 55, 0.6);
  background: rgba(0, 15, 22, 0.04);
  :hover,
  :focus {
    color: rgba(10, 21, 55, 0.62);
    background: rgba(0, 15, 22, 0.06);
  }
  :active {
    color: rgba(10, 21, 55, 0.64);
    background: rgba(0, 15, 22, 0.08);
  }
`;

export const ViewMoreButton = ({ label, pageData, rawData, indexEnd, updateViewData }) => {
  const { t } = useTranslation();
  const [index, setIndexEnd] = useState(indexEnd);
  const count = rawData.length;
  const rows = pageData.length;
  const showMore = rawData.length > index;
  const amountToView = Math.min(count - rows, LIMIT_PAGE);

  const handleClick = (more) => {
    if(more) {
      setIndexEnd(curr => curr + amountToView);
      updateViewData(rawData.slice(0, (index + amountToView)));
    } else {
      setIndexEnd(indexEnd);
      updateViewData(rawData.slice(0, indexEnd));
    };
  };

  return (
    <ContentWrapper>
      {showMore ? (
        <StyledButton onClick={() => handleClick(true)}>
          <StyledSpan>
            {t('View {{amountToView}} more {{label}}', {
              amountToView,
              label: amountToView === 1 ? label?.replace(/s$/, '') : label
            })}
          </StyledSpan>
          <ExpandMore fontSize="small" />
        </StyledButton>
      ) : (
          <StyledButton onClick={() => handleClick(false)}>
            <StyledSpan>{t('Collapse')}</StyledSpan>
            <ExpandLess fontSize="small" />
          </StyledButton>
      )}
    </ContentWrapper>
  );
}
